import React, { useEffect, useState } from 'react';
import { useInfiniteQuery, useQuery } from 'react-query';

import { Box, Grid, Theme, createStyles, makeStyles } from '@material-ui/core';

import Loader from '../../../components/LoaderSplash/Loader.component';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import {
  INCIDENTS_QUERY_CONFIG,
  incidentsQuery,
} from '../../../query/incidents/incidents';
import {
  SINISTER_INSPECTION_QUERY,
  sinisterInspectionsQuery,
} from '../../../query/sinisterInspections/sinisterInspections';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../../query/vehicles/vehicles';
import { myProducts } from '../../../services/products/products.service';
import AssistancesBanner from './AssistancesBanner.component';
import CirculationCards from './CirculationCards.component';
import LinkCards from './LinkCards.component';
import SelfInspectionCard from './SelfInspectionCard.component';
import SinisterCards from './SinisterCards.component';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    subtitle: {
      color: '#000',
      // color: '#0033A0',
      fontFamily: 'Inter',
      fontWeight: 700,
      fontSize: '20px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
        fontWeight: 400,
      },
    },
  })
);

const Dashboard = (props) => {
  const { user } = useAuthDataContext();
  const { loading } = useVehiclesContext();
  const { userEnabled } = useVehiclesContext();
  const classes = useStyle();
  const [listProducts, setListProducts] = useState('');
  const [productsFiltered, setProductsFiltered] = useState([]);
  const [vehiclesHasAssistance, setVehiclesHasAssistance] = useState(false);
  let lastPageEmpty = 0;

  const { data: incidents, isLoading } = useQuery(
    ['incident_detail'],
    incidentsQuery,
    INCIDENTS_QUERY_CONFIG
  );

  const { data } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );

  const {
    data: sinisterInspections,
    isLoading: sinisterInspectionsLoading,
    fetchNextPage,
    hasNextPage: next,
  } = useInfiniteQuery(SINISTER_INSPECTION_QUERY, sinisterInspectionsQuery, {
    getNextPageParam: (lastPage) => {
      lastPageEmpty = lastPage.length;
    },
  });

  const getMyProducts = async () => {
    await myProducts().then((productsDataList) => {
      setListProducts(productsDataList.data);
      setProductsFiltered(
        productsDataList.data.filter((product) => product.code === 4)
      );
    });
  };

  useEffect(() => {
    setVehiclesHasAssistance(
      data?.some((vehicle) => vehicle.assistance_provider?.phone)
    );
  }, [data]);

  useEffect(() => {
    getMyProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dataLayerPush('inicio', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando'}></Loader>
      </Box>
      {!userEnabled && productsFiltered.length > 0 ? (
        <>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={11} lg={11} xl={9}>
              <Grid container>
                <Grid xs={12} container direction="row" justify="space-evenly">
                  <Grid item xs={12}>
                    <Box mt={2}>
                      <SelfInspectionCard />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={11} lg={11} xl={9}>
              <AssistancesBanner></AssistancesBanner>
            </Grid>
            <Grid item xs={11} lg={11} xl={9}>
              <Grid container>
                <Grid container>
                  <Grid item xs={12}>
                    {!isLoading && incidents?.length > 0 && (
                      <>
                        <Box mt={2}>
                          <Box className={classes.subtitle} my={2}>
                            Siniestro en curso
                          </Box>
                          <SinisterCards incidents={incidents}></SinisterCards>
                        </Box>
                      </>
                    )}
                    <Box>
                      {!!listProducts &&
                        !!data &&
                        productsFiltered.length > 0 && (
                          <Box>
                            <Box mt={2}>
                              <Box className={classes.subtitle} my={2}>
                                Tarjeta de circulación
                              </Box>
                              <CirculationCards data={data}></CirculationCards>
                            </Box>
                            <Grid item xs={12}>
                              <Box mt={2}>
                                <SelfInspectionCard />
                              </Box>
                            </Grid>
                          </Box>
                        )}
                    </Box>
                    <Grid item xs={12}>
                      <Box mt={2}>
                        <LinkCards
                          hasProducts={!!listProducts}
                          hasVehicles={productsFiltered.length > 0}
                          hasAssistance={vehiclesHasAssistance}
                          hasSinisterInspections={
                            sinisterInspections?.pages.length > 0 &&
                            sinisterInspections?.pages[0].length > 0
                              ? true
                              : false
                          }
                        ></LinkCards>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default Dashboard;
